
import { defineComponent } from "vue";
import CatalogueSelectControl from "@/components/controls//base/CatalogueSelectControl.vue";
import DxButton from "devextreme-vue/button";
import { DxSelectBox } from "devextreme-vue";
import api from "@/services/api";

export default defineComponent({
  components: {
    CatalogueSelectControl,
    DxButton,
    DxSelectBox,
  },
  methods: {
    async onPlanChange() {
      if (this.model.planId) {
        this.dataSourceOrder = await this.getDataSource(
          "PlanOrderResult",
          this.model.planId,
          "number"
        );
        this.showOrder = true;
        this.showNomenclature = false;
      } else {
        this.dataSourceOrder = null;
        this.showOrder = false;
        this.showNomenclature = false;
      }
      this.selectedOrder = null;
      this.selectedNomenclature = null;
    },
    async onOrderChange() {
      if (this.selectedOrder) {
        this.dataSourceNomenclature = await this.getDataSource(
          "PlanOrderNomenclatureResult",
          this.selectedOrder.id,
          "name"
        );
        this.showNomenclature = true;
      } else {
        this.showNomenclature = false;
        this.dataSourceNomenclature = null;
      }
      this.selectedNomenclature = null;
    },
    getDataSource: async function (controller: any, idParent: any, desc: any) {
      const { data } = await api.get(`/${controller}/GetAll`, {
        params: {
          IdParent: idParent,
        },
      });
      const dataSource = (data as any).data.map((x: any) => {
        return {
          id: x.id,
          desc: x[desc],
        };
      });
      return dataSource;
    },
    onButtonClick() {
      if (this.loading) this.onStop();
      else this.onReport();
    },
    onReport() {
      this.$emit("onReport", this.model.planId, this.resultOptions);
    },
    onStop() {
      this.$emit("onStop");
    },
  },
  props: { loading: { required: false } },
  computed: {
    orderId(): any {
      return this.selectedOrder?.id;
    },
    nomenclatureId(): any {
      return this.selectedNomenclature?.id;
    },
    resultOptions(): any {
      return { orderId: this.orderId, nomenclatureId: this.nomenclatureId };
    },
  },
  data() {
    return {
      model: {},
      dataSourceOrder: null,
      selectedOrder: null,
      showOrder: false,
      dataSourceNomenclature: null,
      selectedNomenclature: null,
      showNomenclature: false,
    };
  },
});
